import React, { useEffect, useState } from 'react';
import { getTrafficLightsData, ITrafficLightData } from '../api/TrafficLights';
import { IMonthValue } from '../util/DateUtils';
import TrafficLight from './TrafficLight';
import './TrafficLight.css'

export interface ITrafficLightsProps {
  report: string;
  type: string;
  period: IMonthValue;
}

const TrafficLights: React.FunctionComponent<ITrafficLightsProps> = (props: ITrafficLightsProps) => {
  const [lights, setLights] = useState([{ color: '', msg: {errorID: 0, value: "", name: ""} }] as ITrafficLightData[]);

  useEffect(() => {
    setLights([{ color: '', msg: {errorID: 0, value: "", name: ""} }] as ITrafficLightData[]);
    getTrafficLightsData(props.report, props.type, props.period.year + "-" + (props.period.month+1)).then((data) => {
      if(data) setLights(data);
    })
  }, [props.period, props.type, props.report]);

  const trafficLights = () => {
    const items: { }[] = [];
    if(lights) {
      lights.forEach((light : ITrafficLightData, index) => {
        items.push(
        <TrafficLight key={index}
          data = { light } >
        </TrafficLight>);
      });
    }
    return items;
  }

  return (
    <div className="TrafficLights">
      { trafficLights() }
    </div>
  )
}

export default TrafficLights;